import { createSelector } from 'reselect'

import { selectWelcomeFlowState } from './selectWelcomeFlowState'

export const selectShowWelcomeFlow = createSelector(
  [selectWelcomeFlowState],
  (state) => state.UserData.length > 0
)
